export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentSpadaysController',
  template: require('../views/pageContent.spadays.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.spadays.component.js